import React from 'react';
import LazyLoad from '../../common/components/LazyLoad';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import { Icon } from '../../common/components/Utilities';

export default function ({ user, start, end }) {
  return (
    <LazyLoad
      resourceAction={LegacyUserResource.estimation}
      params={[user, start, end]}
      defaultData={0}
      render={(loading, { diff, count }) => {
        const formatter = Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 });

        if (loading) {
          return <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />;
        }

        if (diff === 0 || count === 0) {
          return <div className="text-muted text-italic">Not enough data.</div>;
        }

        return (
          <>
            <div className={diff > 0 ? 'text-danger' : 'text-success'}>
              {`${formatter.format(Math.abs(diff))}% ${diff > 0 ? 'over' : 'under'}`}
            </div>
            <div className="small text-muted">
              {`Based on ${count} tickets.`}
            </div>
          </>
        );
      }}
    />
  );
}
